var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejLoanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.761,
    cy: 30.5,
    rx: 30.4367,
    ry: 30.0339,
    fill: "#920583",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2498 16.8333L42.3332 23.9166M26.7498 29.5833L35.2498 38.0833M35.2498 29.5833L26.7498 38.0833M21.0832 45.1666H40.9165C41.2922 45.1666 41.6526 45.0173 41.9182 44.7517C42.1839 44.486 42.3332 44.1256 42.3332 43.7499V23.9166H35.2498V16.8333H21.0832C20.7074 16.8333 20.3471 16.9825 20.0814 17.2482C19.8158 17.5139 19.6665 17.8742 19.6665 18.2499V43.7499C19.6665 44.1256 19.8158 44.486 20.0814 44.7517C20.3471 45.0173 20.7074 45.1666 21.0832 45.1666Z",
    stroke: "#920583",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejLoanIcon);
export default __webpack_public_path__ + "static/media/RejLoanIcon.7b1e1b642bd32fe9273a77b614b888b2.svg";
export { ForwardRef as ReactComponent };